export default __webpack_public_path__ + "static/media/move-arrows.13be6a7c.svg";